import request from '@/helpers/request'
import Vue from 'vue'

export default {
  GET_ALL_NOTIFICATIONS({ commit, state }, params) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.notifications.all}`,
      { params },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setLoad', false)
        commit('setAllNotifications', data)
        return response.data.data
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_UNREAD_NOTIFICATIONS({ commit, state }, params) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.notifications.unread}`,
      { params },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data
        commit('setUnreadNotifications', data)
        return response.data.data
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_READ_NOTIFICATIONS({ commit, state }, params) {
    return request('GET', `${Vue.config.server}/${Vue.config.modules.crm.api.notifications.read}`, {}, true).then(
      response => {
        // console.log(response);
      },
    )
  },
  MARK_NOTIFICATION_AS_READ({ commit, state }, { notificationID }) {
    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.notifications.one.replace('$1', notificationID)}`,
      {},
      true,
    ).then(response => {
      // console.log(response);
    })
  },
  MARK_ALL_NOTIFICATIONS_AS_READ({ commit, state }, params) {
    return request('POST', `${Vue.config.server}/${Vue.config.modules.crm.api.notifications.read}`, {}, true).then(
      response => {
        // console.log(response);
      },
    )
  },
}
